function initLazyScript(element, callback, threshold = 500) {
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof callback === "function") {
              callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: `0px 0px ${threshold}px 0px` }
    );

    io.observe(element);
  } else {
    callback();
  }
}

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/**
 * Gestion de l'affichage du header lors du scroll
 */

const header = document.querySelector("#header");
const body = document.body;
let lastScrollTop = 0;

window.addEventListener("scroll", function () {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > 50) {
    header.classList.add("scrolling-down");
    if (scrollTop < lastScrollTop) {
      header.classList.remove("scrolling-down");
      header.classList.add("scrolling-up");
    }
  } else {
    header.classList.remove("scrolling-down", "scrolling-up");
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "footer-cart-drawer",
        section: "footer-cart-drawer",
        selector: ".footer-cart-drawer",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: ".main-cart-footer",
      },
      {
        id: "main-cart-items-page",
        section: "main-cart-items-page",
        selector: ".main-cart-items-page",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const errorsDiv = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");

        if (parsedState.errors) {
          errorsDiv.textContent = parsedState.errors;
          errorsDiv.style.display = "block";
        } else {
          //this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");

          //On remplace les éléments
          if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementsWithId = document.querySelectorAll(`#${section.id}`);
            elementsWithId.forEach((element) => {
              const elementToReplace = element.querySelector(section.selector) || element;
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            });
          });

          this.disableLoading(line);
        }
      })
      .catch((e) => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) => overlay.classList.add("hidden"));
        const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace("[quantity]", quantityElement.value);
    }

    const textareas = document.querySelectorAll("textarea#CartDrawer-Note");

    textareas.forEach((textarea) => {
      textarea.addEventListener("input", (event) => {
        // Récupérer le texte tapé par l'utilisateur
        const text = event.target.value;

        // Modifier le contenu de tous les éléments textarea avec l'ID "CartDrawer-Note"
        textareas.forEach((textarea) => {
          textarea.innerText = text;
        });
      });
    });

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cursor-not-allowed");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line}`);

    const cartDrawerItemElementsLine = document.getElementById(`CartItem-${line}`);
    cartDrawerItemElementsLine.style.opacity = ".5";

    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cursor-not-allowed");

    const cartDrawerItemElementsLine = document.getElementById(`CartItem-${line}`);
    if (cartDrawerItemElementsLine) {
      cartDrawerItemElementsLine.style.opacity = "1";
    }
  }
}

customElements.define("cart-items", CartItems);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-drawer-items") || this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    //this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination) inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

/*class NoteOrder extends HTMLElement {
    constructor() {
        super();
        this.typingDelay = 600; // 0,3 seconde
    }

    connectedCallback() {
        const textarea = this.querySelector('textarea');
        if (!textarea) return;

        textarea.addEventListener('input', debounce((event) => {

            console.log(event);

            const body = JSON.stringify({note: event.target.value})

            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});

        }, this.typingDelay));
    }
}

customElements.define('note-order', NoteOrder);*/

class ProductRecommendationsCart extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer"); // Assurez-vous que ceci pointe vers votre élément de panier
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.fetchCartAndRecommendations();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
  }

  fetchCartAndRecommendations() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (cart.items.length > 0) {
          const lastProduct = cart.items[cart.items.length - 1];
          const recommendationsUrl = `/recommendations/products.json?product_id=${lastProduct.product_id}&limit=4`;
          return fetch(recommendationsUrl);
        } else {
          throw new Error("Le panier est vide.");
        }
      })
      .then((response) => response.json())
      .then((data) => this.renderRecommendations(data.products))
      .catch((e) => console.error(e));
  }

  renderRecommendations(products) {
    const recommendationsList = document.getElementById("product-recommendations-list");
    let recommendationsHtml = "";

    products.forEach((product) => {
      let price = product.variants[0].price;

      recommendationsHtml += `
                <li class="bg-white h-full min-w-[277px] scroll-mx-6 snap-start rounded p-3.5 grid grid-cols-3 gap-6">
                            <div class="relative h-full w-full bg-gray-100">
                                <img src="${product.images[0]}" alt="${product.title}" class="absolute object-cover h-full w-full">
                            </div>
                            <div class="flex flex-col col-span-2">
                                <div class="flex flex-col">
                                    <span class="text-[#3B3B3B] font-heading text-13 font-[400] tracking-[1.56px] leading-normal uppercase">${product.title}</span>
                                    <span class="text-[#0C0C0C] text-12 font-[380] leading-normal">${price}</span>
                                </div>
                                <div class="mt-auto">
                                    <button data-variant-id="${product.variants[0].id}" class="add-to-cart-btn font-heading text-[#020202] text-10 font-[400] tracking-[1.2px] underline capitalize">
                                        Ajouter
                                    </button>
                                </div>
                            </div>
                        </li>
            `;
    });

    recommendationsList.innerHTML = recommendationsHtml;
    this.attachEventListeners();
  }

  attachEventListeners() {
    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.addEventListener("click", this.addToCart.bind(this));
    });
  }

  addToCart(event) {
    event.preventDefault();
    const variantId = event.target.dataset.variantId;

    console.log(this.cart.getSectionsToRender().map((section) => section.id));

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["Content-Type"] = "application/json";
    config.method = "POST";
    config.body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((data) => {
        if (this.cart) {
          this.cart.renderContents(data);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de l'ajout du produit:", error);
      });
  }
}

customElements.define("product-recommendations-cart", ProductRecommendationsCart);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
  }

  connectedCallback() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    this.observer.observe(this);

    const content = document.createElement("div");
    content.appendChild(this.querySelector("template").content.cloneNode(true));

    const deferredElement = content.querySelector("video, model-viewer, iframe");
    if (deferredElement) {
      this.appendChild(deferredElement);
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadContent();
        this.observer.unobserve(this);
      }
    });
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const deferredElement = this.querySelector("video, model-viewer, iframe");
      if (deferredElement && deferredElement.nodeName === "VIDEO" && deferredElement.getAttribute("autoplay") !== null) {
        // Check if the document has received a user interaction
        const hasUserInteracted = window.matchMedia("(display-mode: standalone)").matches || window.navigator.userAgent.match(/iPhone|iPod|iPad/) || window.navigator.userAgent.toLowerCase().includes("android");

        if (hasUserInteracted) {
          deferredElement.play().catch((error) => {
            console.error("Autoplay failed:", error);
          });
        } else {
          // Show a play button or any other interaction prompt to the user
          // and handle the play action when the user interacts
          deferredElement.addEventListener("play", () => {
            // Handle the play action here
          });
        }
        //Lancement forcé.
        setTimeout(function () {
          document.querySelectorAll("video").forEach((video) => {
            video.play().catch((error) => {
              console.error("Video autoplay failed:", error);
            });
          });
        }, 200);
      }
      this.setAttribute("loaded", true);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
    console.log("id", this.id);
    this.swiperProductGrid = document.getElementById("swiperProductGrid" + this.id);
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        //On initialise le swiper
        const swiperProductGrid = new Swiper(".swiperProductGrid", {
          modules: [window.SwiperModules.Navigation],
          slidesPerView: 1.1,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next-product-recommandations",
            prevEl: ".swiper-button-prev-product-recommandations",
          },
          breakpoints: {
            768: {
              slidesPerView: 2.1,
            },
            1024: {
              slidesPerView: 3,
            },
            1440: {
              slidesPerView: 4,
            },
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class ProductDejavu extends HTMLElement {
  observer = undefined;

  constructor() {
    super();

    this.productGrid = document.getElementById("product-dejavu-grid");
    this.productGridSection = document.querySelector(".product-dejavu");

    console.log(this.productGrid);
  }

  connectedCallback() {
    this.initializeProductDejavu();
  }

  initializeProductDejavu() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadProductsDejavu();
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadProductsDejavu() {
    const productList = this.getCookie("recentProducts");

    console.log(productList);

    //Si productList est vide ou ne contient que le produit actuel, on cache la section
    if (!productList || productList.length === 0 || (productList.length === 1 && productList[0] === window.productData?.handle)) {
      this.productGridSection.classList.add("hidden");
      return;
    }

    productList.forEach(async (productHandle) => {
      if (productHandle === window.productData?.handle) return;
      const divSwiperSlide = document.createElement("div");
      divSwiperSlide.classList.add("swiper-slide");
      const productCard = await this.getProduct(productHandle);
      divSwiperSlide.appendChild(productCard);
      this.productGrid.appendChild(divSwiperSlide);
    });

    //On initialise le swiper
    const swiperProductDejavuGrid = new Swiper(".swiperProductDejavuGrid", {
      modules: [window.SwiperModules.Navigation],
      slidesPerView: 1.1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-dejavu-next",
        prevEl: ".swiper-button-dejavu-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
        },
        1024: {
          slidesPerView: 3.1,
        },
        1440: {
          slidesPerView: 4,
        },
      },
    });
  }

  async getProduct(productHandle) {
    console.log("dataset URL" + this.dataset.url);
    const url = `${this.dataset.url}/products/${productHandle}?view=card`;
    return fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const cardProduct = doc.querySelector("card-product");
        return cardProduct;
      });
  }

  // Fonction pour obtenir la valeur du cookie
  getCookie(name) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
    return cookieValue ? JSON.parse(decodeURIComponent(cookieValue)) : [];
  }
}
customElements.define("product-dejavu", ProductDejavu);

class CardUpsell extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector("cart-drawer");
    this.submitButton = this.querySelector("button[type='submit']");
  }

  connectedCallback() {
    this.submitButton.addEventListener("click", this.addToCart.bind(this));
  }

  async addToCart(event) {
    event.preventDefault();

    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    const config = fetchConfig("javascript");
    config.method = "POST";
    config.headers["Content-Type"] = "application/json";

    var items = [
      {
        id: this.dataset.product,
        quantity: 1,
      },
    ];

    config.body = JSON.stringify({
      items: items,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    await fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        this.cart.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        this.submitButton.setAttribute("aria-disabled", false);
      });
  }
}
customElements.define("card-upsell", CardUpsell);

class MiseATaille extends HTMLElement {
  constructor() {
    super();

    this.openMiseATaille = this.querySelector("input#mise-a-taille");
    this.miseATailleContent = this.querySelector("#mise-a-taille-content");
    this.miseATaillePrice = this.querySelector("#mise-a-taille-price");
    this.initialTaille = Number(this.querySelector("#initial-taille").value);
    this.tailles = this.querySelectorAll("input[name='taille']");
    this.askSize = null;

    //Récupération des informations pour les changements de taille
    this.agrandissementId = this.dataset.agrandissementid;
    this.reductionId = this.dataset.reductionid;
    this.agrandissementPrice = parseFloat(this.dataset.agrandissementprice);
    this.reductionPrice = parseFloat(this.dataset.reductionprice);

    this.productForm = document.querySelector("product-form form");
  }

  connectedCallback() {
    this.openMiseATaille.addEventListener("change", this.toggleMiseATaille.bind(this));

    this.tailles.forEach((taille) => {
      taille.addEventListener("change", this.updateMiseATaillePrice.bind(this));
    });

    console.log(this.productForm);
  }

  toggleMiseATaille() {
    this.miseATailleContent.classList.toggle("hidden");
    this.miseATailleContent.classList.toggle("grid");

    console.log(this.agrandissementId);
    console.log(this.reductionId);
    console.log(this.agrandissementPrice);
    console.log(this.reductionPrice);

    if (!this.openMiseATaille.checked) {
      this.miseATaillePrice.textContent = window.theme.strings.miseATaillePrice;

      this.tailles.forEach((taille) => {
        if (taille.value !== this.initialTaille) {
          taille.checked = false;
          this.removeMiseATailleFromProductForm();
        } else {
          taille.checked = true;
        }
      });
    }
  }

  updateMiseATaillePrice(event) {
    console.log("updateMiseATaillePrice");

    this.askSize = Number(event.target.value);

    if (this.askSize === this.initialTaille) {
      this.miseATaillePrice.textContent = window.theme.strings.miseATaillePrice;
      this.removeMiseATailleFromProductForm();
      this.removeInputProductVariantIdInProductForm();
    } else if (this.askSize < this.initialTaille - 3) {
      console.log("this.askSize < this.initialTaille - 3");
      this.miseATaillePrice.textContent = "Sur devis";
      this.updateProductFormWithMiseATaille(this.askSize);
      this.removeInputProductVariantIdInProductForm();
    } else if (this.askSize > this.initialTaille + 3) {
      this.miseATaillePrice.textContent = "Sur devis";
      this.updateProductFormWithMiseATaille(this.askSize);
      this.removeInputProductVariantIdInProductForm();
    } else {
      if (this.askSize > this.initialTaille) {
        this.miseATaillePrice.textContent = "+ " + this.agrandissementPrice / 100 + "€";
        this.addInputProductVariantIdInProductForm(this.agrandissementId);
      } else {
        this.miseATaillePrice.textContent = "+ " + this.reductionPrice / 100 + "€";
        this.addInputProductVariantIdInProductForm(this.reductionId);
      }
      this.updateProductFormWithMiseATaille(this.askSize);
    }
  }

  addInputProductVariantIdInProductForm(id) {
    console.log("addInputProductVariantIdInProductForm");

    //Check if the hidden input already exists, replace it if it does
    if (this.productForm.querySelector("input[name='properties[_id_mise_a_taille]']")) {
      this.productForm.querySelector("input[name='properties[_id_mise_a_taille]']").value = id;
      return;
    }

    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "properties[_id_mise_a_taille]";
    hiddenInput.value = id;
    this.productForm.appendChild(hiddenInput);
  }

  removeInputProductVariantIdInProductForm() {
    console.log("removeInputProductVariantIdInProductForm");
    const hiddenInput = this.productForm.querySelector("input[name='properties[_id_mise_a_taille]']");
    if (hiddenInput) {
      hiddenInput.remove();
    }
  }

  removeMiseATailleFromProductForm() {
    const hiddenInput = this.productForm.querySelector("input[name='properties[Mise à la taille]']");
    if (hiddenInput) {
      hiddenInput.remove();
    }
  }

  updateProductFormWithMiseATaille(tailleValue) {
    console.log("updateProductFormWithMiseATaille");

    //Check if the hidden input already exists, replace it if it does
    if (this.productForm.querySelector("input[name='properties[Mise à la taille]']")) {
      this.productForm.querySelector("input[name='properties[Mise à la taille]']").value = tailleValue;
      return;
    }

    //Create a hidden input with the value of the selected taille
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "properties[Mise à la taille]";
    hiddenInput.value = tailleValue;
    this.productForm.appendChild(hiddenInput);
  }
}
customElements.define("mise-a-taille", MiseATaille);

class ProductAlert extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.submitButton = this.querySelector("button");

    this.form.addEventListener("submit", this.submitForm.bind(this));

    this.thanks = this.querySelector("#product-alert-thanks");

    //Data
    this.productId = null;
    this.productType = null;
    this.productBrand = null;
    this.productMatiere = null;
    this.productPierre = null;
    this.productModeleBagues = null;
    this.productModeleMontres = null;
    this.productModeleBracelets = null;
    this.productModeleBouclesOreilles = null;
    this.productModeleCollier = null;
  }

  connectedCallback() {
    this.submitButton.addEventListener("click", this.submitForm.bind(this));
  }

  submitForm(event) {
    event.preventDefault();

    //Vérification de l'email en Regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.form.querySelector("input[name='email']").value)) {
      this.form.classList.add("error");
      return;
    } else {
      this.form.classList.remove("error");
    }

    // Affichage de l'erreur
    if (!this.form.querySelector("input[name='Accepts Marketing']").checked) {
      this.form.classList.add("error");
      return;
    } else {
      this.form.classList.remove("error");
    }

    //Récupération des données
    this.productName = this.form.querySelector("input[name='product_name']").value;
    this.productId = this.form.querySelector("input[name='product_id']").value;
    this.productType = this.form.querySelector("input[name='product_type']").value;
    this.productBrand = this.form.querySelector("input[name='product_brand']").value;
    this.productMatiere = this.form.querySelector("input[name='product_matiere']").value.split(",");
    this.productPierre = this.form.querySelector("input[name='product_pierre']").value.split(",");

    //Modèle
    this.productModeleBagues = this.form.querySelector("input[name='product_modele_bagues']").value.split(",");
    this.productModeleMontres = this.form.querySelector("input[name='product_modele_montres']").value.split(",");
    this.productModeleBracelets = this.form.querySelector("input[name='product_modele_bracelets']").value.split(",");
    this.productModeleBouclesOreilles = this.form.querySelector("input[name='product_modele_boucles_oreilles']").value.split(",");
    this.productModeleCollier = this.form.querySelector("input[name='product_modele_collier']").value.split(",");

    //Track the interest in the product
    this.trackInterestInProduct(
      this.form.querySelector("input[name='email']").value,
      this.productName,
      this.productId,
      this.productType,
      this.productBrand,
      this.productMatiere,
      this.productPierre,
      this.productModeleBagues,
      this.productModeleMontres,
      this.productModeleBracelets,
      this.productModeleBouclesOreilles,
      this.productModeleCollier
    );
  }

  trackInterestInProduct(email, productName, productId, productType, productBrand, productMatiere, productPierre, productModeleBagues, productModeleMontres, productModeleBracelets, productModeleBouclesOreilles, productModeleCollier) {
    if (typeof window._learnq === "undefined") {
      console.error("Klaviyo script is not loaded yet.");
      return;
    }

    // Abonne l'utilisateur à la liste Klaviyo
    const listId = "Ta7yX5";
    fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        g: listId,
        email: email,
        $consent: "email",
      }),
    });

    // Identifie l'utilisateur
    window._learnq.push([
      "identify",
      {
        $email: email,
        $consent: ["email"],
      },
    ]);

    // Envoie l'événement personnalisé
    window._learnq.push([
      "track",
      "Interest in Product",
      {
        interested_in: productName,
        product_id: productId,
        product_type: productType,
        ...(productBrand ? { product_brand: productBrand } : { product_brand: "NonSigné" }),
        ...(productMatiere[0] !== "" ? { product_matiere: productMatiere } : {}),
        ...(productPierre[0] !== "" ? { product_pierre: productPierre } : {}),
        ...(productModeleBagues[0] !== "" ? { product_modele_bagues: productModeleBagues } : {}),
        ...(productModeleMontres[0] !== "" ? { product_modele_montres: productModeleMontres } : {}),
        ...(productModeleBracelets[0] !== "" ? { product_modele_bracelets: productModeleBracelets } : {}),
        ...(productModeleBouclesOreilles[0] !== "" ? { product_modele_boucles_oreilles: productModeleBouclesOreilles } : {}),
        ...(productModeleCollier[0] !== "" ? { product_modele_collier: productModeleCollier } : {}),
      },
    ]);

    console.log("Tracked Interest in Product:", productName);

    // Remerciement pour l'inscription
    this.thanks.classList.remove("hidden");
    this.form.classList.add("hidden");
  }
}
customElements.define("product-alert", ProductAlert);

class searchPopup extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.seeAllResultsButton = this.querySelector("#predictive-search-see-all-results");

    // Focus automatique sur l'input
    if (this.input) {
      this.input.focus();
    }

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    //Predictive search
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.abortController = new AbortController();
    this.searchTerm = "";

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener("reset", this.onFormReset.bind(this));
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    //this.seeAllResultsButton.addEventListener("click", this.seeAllResults.bind(this));

    this.initializeSearch(this.getQuery());

    /* this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this)); */
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  seeAllResults() {
    console.log("seeAllResults");
    this.input.form.submit();
  }

  onChange() {
    this.toggleResetButton();

    const newSearchTerm = this.getQuery();

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.getSearchNoResult();
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  getSearchNoResult() {
    //Récupérer la section search-popup #predictive-search-results
    fetch(`/?section_id=search-popup`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#predictive-search-results").innerHTML;
        /*   // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
 */
        this.predictiveSearchResults.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        //this.close();
        throw error;
      });
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[options][fields]=title,product_type,variants.title,body,tag&resources[options][unavailable_products]=hide&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          //this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#predictive-search-results").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        //this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      //searchForTextElement.innerText = newButtonText;
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }

    this.getSearchNoResult();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  initializeSearch(searchTerm) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.getSearchResults(searchTerm);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }
}
customElements.define("search-popup", searchPopup);

window.addEventListener("search-changed", (event) => {
  console.log("La valeur de search a changé :", event.detail.value);
  if (event.detail.value === true) {
    const searchInput = document.querySelector("#search-input");
    console.log(searchInput);
    if (searchInput) {
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    }
  }
});
// Script pour ouvrir la modale si l'URL contient le paramètre spécifique
document.addEventListener("DOMContentLoaded", (event) => {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;

  // Vérifie si l'URL contient le paramètre 'contact_posted=true' et le hash '#offre'
  if (urlParams.get("contact_posted") && hash === "#offre") {
    window.dispatchEvent(new CustomEvent("open-offer-modal"));
  }
});
